export const AIR_CONDITION_SYSTEM = {
  STATUS: {
    DRIVER_HVAC_COMMUNICATION_ERROR: 1,
    DRIVER_HVAC_MAJOR_ERROR: 1,
    DRIVER_HVAC_MINOR_ERROR: 1,
    DRIVER_HVAC_CLOSED: 1,
    HVAC_1_COMMUNICATION_ERROR: 1,
    HVAC_1_MAJOR_ERROR: 1,
    HVAC_1_MINOR_ERROR: 1,
    HVAC_1_CLOSED: 1,
    HVAC_2_COMMUNICATION_ERROR: 1,
    HVAC_2_MAJOR_ERROR: 1,
    HVAC_2_MINOR_ERROR: 1,
    HVAC_2_CLOSED: 1
  }
} as const;
